/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import { __ } from '@wordpress/i18n';
import { useSearchParams } from 'react-router-dom';

import FilterCheckbox from './FilterCheckbox';
/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
function Filter({ type, values, refetchCallback }) {
	const [searchParams, setSearchParams] = useSearchParams();

	if (!values || values.length === 0) {
		return null;
	}

	return (
		<>
			<div className="course__filter">
				{values.map((value) => (
					<FilterCheckbox
						key={`${value.slug}-${value.term_id}`}
						id={value.term_id}
						type={type}
						label={value.name}
						slug={value.slug}
						searchParams={searchParams}
						setSearchParams={setSearchParams}
					/>
				))}
			</div>
		</>
	);
}

export default Filter;
